module.exports = __webpack_public_path__ + "static/media/check.13417096.svg";